import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { HeadingBlockData } from '../../../../models/courses';

interface HeadingBlockProps {
  data: HeadingBlockData;
  onChange: (_data: HeadingBlockData) => void;
  disabled?: boolean;
}

export const HeadingBlock: React.FC<HeadingBlockProps> = ({
  data,
  onChange,
  disabled,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      <FormControl size="small" sx={{ maxWidth: 120 }} disabled={disabled}>
        <InputLabel>Уровень</InputLabel>
        <Select
          value={data.level}
          label="Уровень"
          onChange={(e) =>
            onChange({ ...data, level: e.target.value as number })
          }
        >
          {[1, 2, 3, 4, 5, 6].map((l) => (
            <MenuItem key={l} value={l}>
              H{l}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TextField
        label="Текст заголовка"
        size="small"
        fullWidth
        value={data.text}
        onChange={(e) => onChange({ ...data, text: e.target.value })}
        disabled={disabled}
      />
    </Box>
  );
};
